import { type CoreListing, ListingStatus } from '@kijiji/generated/graphql-types'
import { useRouter } from 'next/router'

import { GA_PAGE_TYPE } from '@/lib/ga/constants/datalayer'
import { useTracking } from '@/lib/ga/hooks/useTracking'
import { type DataLayerListing } from '@/lib/ga/types/dataLayer'
import { getDatalayerListing } from '@/lib/ga/utils/getDatalayerListing'
import { getDatalayerSearch } from '@/lib/ga/utils/getDatalayerSearch'
import { type VipQueryListing } from '@/types/listings'

/**
 * Custom fields for VIP-specific data layer
 */
export type VipDatalayer = DataLayerListing

type useVipTrackingProps = {
  listing?: VipQueryListing | null
  /** List of listings returned on eVip */
  eVipListings?: CoreListing[]
}

export const useVipTracking = ({ listing, eVipListings }: useVipTrackingProps) => {
  const { asPath } = useRouter()
  const vipDataLayer = getDatalayerListing(listing)
  const isEVIP = listing?.status !== ListingStatus.Expired

  /**
   * eVips will display similar listings instead of the ad
   * We need to append Impression tracking for them on the datalayer
   */
  const eVipSearchData =
    isEVIP && eVipListings?.length
      ? getDatalayerSearch({
          asPath,
          listingsData: eVipListings,
        })
      : undefined

  useTracking({
    categoryId: listing?.categoryId,
    locationId: listing?.location.id,
    pageData: { ...vipDataLayer, ...eVipSearchData },
    pageType: isEVIP ? GA_PAGE_TYPE.VIEW_EXPIRED_AD : GA_PAGE_TYPE.VIEW_AD,
  })
}
